import SortSelect from './SortSelect.component';

export default SortSelect;